(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wh-lighting-presentation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wh-product-scroll')) {
    customElements.define('wh-product-scroll', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.track = this.querySelector('.wh-scroll-track');
        this.visible = false;
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.init();
          this.updateAutoplay();
        }, { threshold: 0.2 });
        this.observer.observe(this);
        const signal = this.abort.signal;
        document.addEventListener('DOMContentLoaded', () => { if (this.visible) { this.init(); this.updateAutoplay(); } }, { signal, once: true });
        this.addEventListener('focusin', event => { this.keyboardFocus = event.target.matches(':focus-visible'); this.updateAutoplay(); }, { signal });
        this.addEventListener('focusout', () => queueMicrotask(() => {
          this.keyboardFocus = this.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
          this.updateAutoplay();
        }), { signal });
        this.addEventListener('pointerdown', () => { this.keyboardFocus = false; this.updateAutoplay(); }, { signal, passive: true });
        this.addEventListener('mouseenter', () => { if (matchMedia('(hover:hover)').matches) { this.hovered = true; this.updateAutoplay(); } }, { signal });
        this.addEventListener('mouseleave', () => { this.hovered = false; this.updateAutoplay(); }, { signal });
        document.addEventListener('visibilitychange', () => this.updateAutoplay(), { signal });
        this.reduced.addEventListener('change', () => this.updateAutoplay(), { signal });
      }
      init() {
        if (this.carousel || !window.FoxTheme?.Carousel) return;
        const scenes = this.dataset.kind === 'scenes';
        const count = this.track.querySelectorAll('.swiper-slide').length;
        const options = {
          slidesPerView: scenes ? 'auto' : 1,
          spaceBetween: scenes ? 12 : 0,
          speed: this.reduced.matches ? 0 : 550,
          loop: !scenes && count > 1,
          rewind: scenes,
          watchOverflow: true,
          grabCursor: count > 1,
          lazyPreloadPrevNext: 1,
          autoplay: { delay: Number(this.dataset.delay || 5) * 1000, disableOnInteraction: false, pauseOnMouseEnter: false },
          navigation: { nextEl: this.querySelector('[data-wh-scroll-next]'), prevEl: this.querySelector('[data-wh-scroll-prev]') },
          breakpoints: scenes ? { 768: { slidesPerView: 2, spaceBetween: 24 }, 1024: { slidesPerView: 3, spaceBetween: 24 } } : {},
          a11y: { containerMessage: this.getAttribute('aria-label') }
        };
        this.carousel = new FoxTheme.Carousel(this.track, options, [FoxTheme.Swiper.Autoplay]);
        this.carousel.init();
        const slider = this.carousel.slider;
        slider.autoplay.stop();
        const update = () => {
          const counter = this.querySelector('[data-wh-scroll-count]');
          if (counter) counter.textContent = (slider.realIndex + 1) + ' / ' + count;
          this.dataset.locked = slider.isLocked || count < 2 ? 'true' : 'false';
          this.updateAutoplay();
        };
        slider.on('slideChange', () => { const counter = this.querySelector('[data-wh-scroll-count]'); if (counter) counter.textContent = (slider.realIndex + 1) + ' / ' + count; });
        slider.on('lock unlock resize', update);
        this.track.querySelector('.swiper-wrapper').setAttribute('aria-live', 'off');
        update();
        if (scenes && FoxTheme.PhotoSwipeLightbox && FoxTheme.PhotoSwipe) {
          this.lightbox = new FoxTheme.PhotoSwipeLightbox({ gallery: this.track, children: 'a[data-wh-zoom]', pswpModule: FoxTheme.PhotoSwipe, bgOpacity: 0.96 });
          this.lightbox.on('beforeOpen', () => { this.lightboxOpen = true; this.updateAutoplay(); });
          this.lightbox.on('destroy', () => { this.lightboxOpen = false; this.updateAutoplay(); });
          this.lightbox.init();
        }
      }
      updateAutoplay() {
        const slider = this.carousel?.slider;
        if (!slider || slider.destroyed) return;
        const paused = !this.autoplayEnabled || this.reduced.matches || this.keyboardFocus || this.lightboxOpen;
        const run = !paused && this.visible && !this.hovered && !document.hidden && !slider.isLocked;
        if (run && !slider.autoplay.running) slider.autoplay.start();
        if (!run && slider.autoplay.running) slider.autoplay.stop();
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.lightbox?.destroy(); this.carousel?.slider?.destroy(); this.carousel = null; }
    });
  }
  if (!customElements.get('wh-option-strip')) {
    customElements.define('wh-option-strip', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.track = this.querySelector('.wh-option-track');
        const previous = this.querySelector('[data-wh-option-prev]');
        const next = this.querySelector('[data-wh-option-next]');
        const signal = this.abort.signal;
        const update = () => { previous.disabled = this.track.scrollLeft < 3; next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 3; };
        const move = direction => this.track.scrollBy({ left: direction * Math.max(104, this.track.clientWidth - 52), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        previous.addEventListener('click', () => move(-1), { signal }); next.addEventListener('click', () => move(1), { signal });
        this.track.addEventListener('scroll', update, { signal, passive: true });
        const reveal = input => { if (!input || !matchMedia('(max-width:767px)').matches) return; const label = input.nextElementSibling; if (!label) return; const l = label.getBoundingClientRect(); const t = this.track.getBoundingClientRect(); this.track.scrollLeft += l.left - t.left - (t.width - l.width) / 2; };
        this.addEventListener('focusin', event => { if (event.target.matches('input')) reveal(event.target); }, { signal });
        this.resize = new ResizeObserver(update); this.resize.observe(this.track);
        requestAnimationFrame(() => { reveal(this.querySelector('input:checked')); update(); });
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
    });
  }
  if (!customElements.get('wh-detail-image')) {
    customElements.define('wh-detail-image', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const fold = this.closest('details'); const modal = this.closest('basic-modal');
        const load = () => { if ((!fold || fold.open) && (!modal || modal.hasAttribute('active'))) this.load(); };
        if (fold) fold.addEventListener('toggle', load, { signal: this.abort.signal });
        if (modal) { this.observer = new MutationObserver(load); this.observer.observe(modal, { attributes: true, attributeFilter: ['active'] }); }
        load();
      }
      load() {
        const source = this.querySelector('template'); if (!source) return;
        source.replaceWith(source.content.cloneNode(true));
        if (window.FoxTheme?.PhotoSwipeLightbox && FoxTheme.PhotoSwipe) { this.lightbox = new FoxTheme.PhotoSwipeLightbox({ gallery: this, children: 'a[data-wh-zoom]', pswpModule: FoxTheme.PhotoSwipe }); this.lightbox.init(); }
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.lightbox?.destroy(); }
    });
  }
  let whBackToTopCleanup;
  function whSyncBackToTopOffset() {
    whBackToTopCleanup?.();
    whBackToTopCleanup = null;
    if (!document.body.classList.contains('grid-2-col-lightning')) return;
    const arrow = document.querySelector('back-to-top');
    const bar = document.querySelector('sticky-atc-bar-minimalist');
    if (!arrow || !bar) return;
    // Reuse Hyper's existing clearance variable for its minimalist sticky bar.
    const update = () => {
      const style = getComputedStyle(bar);
      const visible = bar.classList.contains('sticky-atc-bar--show') && style.display !== 'none';
      const clearance = visible ? bar.offsetHeight + (parseFloat(style.bottom) || 0) : 0;
      arrow.style.setProperty('--sticky-atc-bar-height', clearance + 'px');
    };
    const resize = new ResizeObserver(update);
    const state = new MutationObserver(update);
    resize.observe(bar);
    state.observe(bar, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    update();
    whBackToTopCleanup = () => {
      resize.disconnect();
      state.disconnect();
      arrow.style.removeProperty('--sticky-atc-bar-height');
    };
  }
  whSyncBackToTopOffset();
  document.addEventListener('DOMContentLoaded', whSyncBackToTopOffset, { once: true });
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(whSyncBackToTopOffset));
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(whSyncBackToTopOffset));
  function whLoadDesktopPictures(root = document) {
    if (!matchMedia('(min-width:768px)').matches) return;
    root.querySelectorAll('template[data-wh-desktop-image]').forEach(source => source.replaceWith(source.content.cloneNode(true)));
  }
  whLoadDesktopPictures();
  matchMedia('(min-width:768px)').addEventListener('change', () => whLoadDesktopPictures());
  document.addEventListener('shopify:section:load', event => whLoadDesktopPictures(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wh-lounge-presentation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wh-product-scroll')) {
    customElements.define('wh-product-scroll', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.track = this.querySelector('.wh-scroll-track');
        this.visible = false;
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.init();
          this.updateAutoplay();
        }, { threshold: 0.2 });
        this.observer.observe(this);
        const signal = this.abort.signal;
        document.addEventListener('DOMContentLoaded', () => { if (this.visible) { this.init(); this.updateAutoplay(); } }, { signal, once: true });
        this.addEventListener('focusin', event => { this.keyboardFocus = event.target.matches(':focus-visible'); this.updateAutoplay(); }, { signal });
        this.addEventListener('focusout', () => queueMicrotask(() => {
          this.keyboardFocus = this.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
          this.updateAutoplay();
        }), { signal });
        this.addEventListener('pointerdown', () => { this.keyboardFocus = false; this.updateAutoplay(); }, { signal, passive: true });
        this.addEventListener('mouseenter', () => { if (matchMedia('(hover:hover)').matches) { this.hovered = true; this.updateAutoplay(); } }, { signal });
        this.addEventListener('mouseleave', () => { this.hovered = false; this.updateAutoplay(); }, { signal });
        document.addEventListener('visibilitychange', () => this.updateAutoplay(), { signal });
        this.reduced.addEventListener('change', () => this.updateAutoplay(), { signal });
      }
      init() {
        if (this.carousel || !window.FoxTheme?.Carousel) return;
        const scenes = this.dataset.kind === 'scenes';
        const count = this.track.querySelectorAll('.swiper-slide').length;
        const options = {
          slidesPerView: scenes ? 'auto' : 1,
          spaceBetween: scenes ? 12 : 0,
          speed: this.reduced.matches ? 0 : 550,
          loop: !scenes && count > 1,
          rewind: scenes,
          watchOverflow: true,
          grabCursor: count > 1,
          lazyPreloadPrevNext: 1,
          autoplay: { delay: Number(this.dataset.delay || 5) * 1000, disableOnInteraction: false, pauseOnMouseEnter: false },
          navigation: { nextEl: this.querySelector('[data-wh-scroll-next]'), prevEl: this.querySelector('[data-wh-scroll-prev]') },
          breakpoints: scenes ? { 768: { slidesPerView: 2, spaceBetween: 24 }, 1024: { slidesPerView: 3, spaceBetween: 24 } } : {},
          a11y: { containerMessage: this.getAttribute('aria-label') }
        };
        this.carousel = new FoxTheme.Carousel(this.track, options, [FoxTheme.Swiper.Autoplay]);
        this.carousel.init();
        const slider = this.carousel.slider;
        slider.autoplay.stop();
        const update = () => {
          const counter = this.querySelector('[data-wh-scroll-count]');
          if (counter) counter.textContent = (slider.realIndex + 1) + ' / ' + count;
          this.dataset.locked = slider.isLocked || count < 2 ? 'true' : 'false';
          this.updateAutoplay();
        };
        slider.on('slideChange', () => { const counter = this.querySelector('[data-wh-scroll-count]'); if (counter) counter.textContent = (slider.realIndex + 1) + ' / ' + count; });
        slider.on('lock unlock resize', update);
        this.track.querySelector('.swiper-wrapper').setAttribute('aria-live', 'off');
        update();
        if (scenes && FoxTheme.PhotoSwipeLightbox && FoxTheme.PhotoSwipe) {
          this.lightbox = new FoxTheme.PhotoSwipeLightbox({ gallery: this.track, children: 'a[data-wh-zoom]', pswpModule: FoxTheme.PhotoSwipe, bgOpacity: 0.96 });
          this.lightbox.on('beforeOpen', () => { this.lightboxOpen = true; this.updateAutoplay(); });
          this.lightbox.on('destroy', () => { this.lightboxOpen = false; this.updateAutoplay(); });
          this.lightbox.init();
        }
      }
      updateAutoplay() {
        const slider = this.carousel?.slider;
        if (!slider || slider.destroyed) return;
        const paused = !this.autoplayEnabled || this.reduced.matches || this.keyboardFocus || this.lightboxOpen;
        const run = !paused && this.visible && !this.hovered && !document.hidden && !slider.isLocked;
        if (run && !slider.autoplay.running) slider.autoplay.start();
        if (!run && slider.autoplay.running) slider.autoplay.stop();
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.lightbox?.destroy(); this.carousel?.slider?.destroy(); this.carousel = null; }
    });
  }
  if (!customElements.get('wh-option-strip')) {
    customElements.define('wh-option-strip', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.track = this.querySelector('.wh-option-track');
        const previous = this.querySelector('[data-wh-option-prev]');
        const next = this.querySelector('[data-wh-option-next]');
        const signal = this.abort.signal;
        const update = () => { previous.disabled = this.track.scrollLeft < 3; next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 3; };
        const move = direction => this.track.scrollBy({ left: direction * Math.max(104, this.track.clientWidth - 52), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        previous.addEventListener('click', () => move(-1), { signal }); next.addEventListener('click', () => move(1), { signal });
        this.track.addEventListener('scroll', update, { signal, passive: true });
        const reveal = input => { if (!input || !matchMedia('(max-width:767px)').matches) return; const label = input.nextElementSibling; if (!label) return; const l = label.getBoundingClientRect(); const t = this.track.getBoundingClientRect(); this.track.scrollLeft += l.left - t.left - (t.width - l.width) / 2; };
        this.addEventListener('focusin', event => { if (event.target.matches('input')) reveal(event.target); }, { signal });
        this.resize = new ResizeObserver(update); this.resize.observe(this.track);
        requestAnimationFrame(() => { reveal(this.querySelector('input:checked')); update(); });
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
    });
  }
  if (!customElements.get('wh-lounge-detail-image')) {
    customElements.define('wh-lounge-detail-image', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const fold = this.closest('details'); const modal = this.closest('basic-modal');
        const load = () => { if ((!fold || fold.open) && (!modal || modal.hasAttribute('active'))) this.load(); };
        if (fold) fold.addEventListener('toggle', load, { signal: this.abort.signal });
        if (modal) { this.observer = new MutationObserver(load); this.observer.observe(modal, { attributes: true, attributeFilter: ['active'] }); }
        window.addEventListener('load', load, { once: true, signal: this.abort.signal });
        this.addEventListener('click', event => {
          const link = event.target.closest('a[data-wh-zoom]');
          if (link && !this.lightbox && this.setupLightbox()) {
            event.preventDefault();
            this.lightbox.loadAndOpen([...this.querySelectorAll('a[data-wh-zoom]')].indexOf(link));
          }
        }, { signal: this.abort.signal });
        load();
      }
      load() {
        const source = this.querySelector('template');
        if (source) source.replaceWith(source.content.cloneNode(true));
        this.setupLightbox();
      }
      setupLightbox() {
        if (this.lightbox) return true;
        if (!this.querySelector('a[data-wh-zoom]') || !window.FoxTheme?.PhotoSwipeLightbox || !FoxTheme.PhotoSwipe) return false;
        this.lightbox = new FoxTheme.PhotoSwipeLightbox({ gallery: this, children: 'a[data-wh-zoom]', pswpModule: FoxTheme.PhotoSwipe });
        this.lightbox.init();
        return true;
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.lightbox?.destroy(); }
    });
  }
  let whBackToTopCleanup;
  function whSyncBackToTopOffset() {
    whBackToTopCleanup?.();
    whBackToTopCleanup = null;
    if (!document.body.matches('.grid-2-col-lightning-lounge-chair, .horizontal-thumbnails-chair-n-sofa')) return;
    const arrow = document.querySelector('back-to-top');
    const bar = document.querySelector('sticky-atc-bar-minimalist');
    if (!arrow || !bar) return;
    // Reuse Hyper's existing clearance variable for its minimalist sticky bar.
    const update = () => {
      const style = getComputedStyle(bar);
      const visible = bar.classList.contains('sticky-atc-bar--show') && style.display !== 'none';
      const clearance = visible ? bar.offsetHeight + (parseFloat(style.bottom) || 0) : 0;
      arrow.style.setProperty('--sticky-atc-bar-height', clearance + 'px');
    };
    const resize = new ResizeObserver(update);
    const state = new MutationObserver(update);
    resize.observe(bar);
    state.observe(bar, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    update();
    whBackToTopCleanup = () => {
      resize.disconnect();
      state.disconnect();
      arrow.style.removeProperty('--sticky-atc-bar-height');
    };
  }
  whSyncBackToTopOffset();
  document.addEventListener('DOMContentLoaded', whSyncBackToTopOffset, { once: true });
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(whSyncBackToTopOffset));
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(whSyncBackToTopOffset));
  function whLoadDesktopPictures(root = document) {
    if (!matchMedia('(min-width:768px)').matches) return;
    root.querySelectorAll('template[data-wh-desktop-image]').forEach(source => source.replaceWith(source.content.cloneNode(true)));
  }
  whLoadDesktopPictures();
  matchMedia('(min-width:768px)').addEventListener('change', () => whLoadDesktopPictures());
  document.addEventListener('shopify:section:load', event => whLoadDesktopPictures(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wh-lounge-visuals"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('wh-lounge-visuals'))customElements.define('wh-lounge-visuals',class extends HTMLElement{
    connectedCallback(){this.controller=new AbortController();this.refresh();document.addEventListener('DOMContentLoaded',()=>this.refresh(),{once:true,signal:this.controller.signal});window.addEventListener('load',()=>this.setupLightbox(),{once:true,signal:this.controller.signal});this.addEventListener('click',e=>{const b=e.target.closest('[data-visual-index]');if(b)this.carousel?.slider?.slideTo(Number(b.dataset.visualIndex));const a=e.target.closest('a[data-wh-zoom]');if(a&&!this.lightbox&&this.setupLightbox()){e.preventDefault();this.lightbox.loadAndOpen([...this.querySelectorAll('a[data-wh-zoom]')].indexOf(a));}},{signal:this.controller.signal});}
    setupLightbox(){if(this.lightbox)return true;if(!window.FoxTheme?.PhotoSwipeLightbox||!FoxTheme.PhotoSwipe)return false;this.lightbox=new FoxTheme.PhotoSwipeLightbox({gallery:this.querySelector('.wh-supplier-track'),children:'a[data-wh-zoom]',pswpModule:FoxTheme.PhotoSwipe});this.lightbox.init();return true;}
    refresh(){if(this.hidden)return;this.setupLightbox();if(this.carousel){requestAnimationFrame(()=>this.carousel.slider?.update());return;}if(!window.FoxTheme?.Carousel){this.retry=setTimeout(()=>this.refresh(),250);return;}this.carousel=new FoxTheme.Carousel(this.querySelector('.wh-supplier-track'),{slidesPerView:1,spaceBetween:0,speed:matchMedia('(prefers-reduced-motion: reduce)').matches?0:400,rewind:true,grabCursor:true,navigation:{prevEl:this.querySelector('[data-visual-prev]'),nextEl:this.querySelector('[data-visual-next]')}});this.carousel.init();this.carousel.slider.on('slideChange',()=>this.querySelectorAll('[data-visual-index]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.visualIndex)===this.carousel.slider.realIndex))));this.setupLightbox();}
    disconnectedCallback(){this.controller?.abort();clearTimeout(this.retry);this.carousel?.slider?.destroy();this.lightbox?.destroy();}
  });
  } catch(e) { console.error(e); }
})();

})();
